module.exports = __webpack_public_path__ + "img/logo_landscape_light.3de13654.svg";